/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL} from '../../../config';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {tableAPIMethod} from '../../utils/tableAPIMethod';

const nzmAPI = async (
  type: APIType,
  routeType: string,
  selectedYear: string,
  data: any = undefined
): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyId = useCompanyStore.getState().companyId;

  try {
    const response = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${routeType}/${companyId}/${selectedYear}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });

    if (type === APITypeEnum.GET_ALL) {
      return response.data.data;
    } else {
      return response.data.data;
    }
  } catch (err) {
    console.log('err:', err);
  }
};

export default nzmAPI;
